import loadingAnimation from './assets/ball-loading.gif';

export function BallLoading({ width = '6', height = '6' }: { width?: string, height?: string }) {
  return (
    <img src={loadingAnimation} className={`w-${width} h-${height}`} />
  )
}